import { IconProps } from './props';
import React from 'react';

export const PencilIcon = (props: IconProps) => (
	<svg
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M17.7927 1.29296C18.1589 0.926847 18.7379 0.904253 19.1306 1.2246L19.2068 1.29296L23.2068 5.29296L23.2752 5.36913C23.5955 5.76191 23.5729 6.34091 23.2068 6.70703C22.8407 7.07314 22.2617 7.09574 21.8689 6.77538L21.7927 6.70703L17.7927 2.70703L17.7244 2.63085C17.404 2.23808 17.4266 1.65908 17.7927 1.29296Z"
			fill={props.fillColor ?? 'black'}
		/>
		<path
			d="M14.8691 4.2246C15.2619 3.90425 15.8409 3.92685 16.207 4.29296L20.207 8.29296L20.2754 8.36913C20.5957 8.76191 20.5731 9.34091 20.207 9.70703L8.70702 21.207C8.58396 21.3301 8.43057 21.419 8.26268 21.4648L2.76268 22.9648C2.41659 23.0591 2.0466 22.9607 1.79295 22.707C1.5393 22.4534 1.44091 22.0834 1.53514 21.7373L3.03514 16.2373L3.07713 16.1143C3.1272 15.9945 3.20057 15.8853 3.29295 15.793L14.793 4.29296L14.8691 4.2246ZM4.89452 17.0185L3.92479 20.5742L7.48045 19.6045L18.0859 8.99999L15.5 6.41406L4.89452 17.0185Z"
			fill={props.fillColor ?? 'black'}
		/>
	</svg>
);
